import React from 'react';
import Wrapper from "../components/Wrapper";
import ButtonLink from "../components/ButtonLink";
import Picture1 from "../assets/Images/picture1.png"
import CodingEnv from "../assets/Images/coding-env.png"
import Access from "../assets/Images/access-anywhere.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {Helmet} from "react-helmet-async";
import {faClose, faMobileAndroid} from "@fortawesome/free-solid-svg-icons";
import {faAndroid} from "@fortawesome/free-brands-svg-icons";
import Button from "../components/Button";
import ButtonLinkHref from "../components/ButtonLinkHref";

const Home = () => {

    return (
        <>
            <Helmet>
                <title>کد پرو - آموزش برنامه نویسی به روش تعاملی</title>
                <link rel="canonical" href='https://code-pro.ir/'/>
                <meta name="description"
                      content="پلتفرم آموزش برنامه نویسی به ورش تعاملی و تمرین‌محور!"/>
            </Helmet>
            <Header/>
            <main className='min-h-screen'>
                <section className="relative flex my-16">
                    <Wrapper>
                        <div className="relative z-10">
                            <div className="text-light-primary">
                                <div className="w-1/2 lg:w-1/6 md:w-1/4 m-auto flex justify-center items-center relative">
                                    <img
                                        src={Picture1}
                                        alt="teenage boy coding on phone using codepro app"
                                        className="w-full"
                                    />
                                </div>
                                <h1 className="text-2xl md:text-3xl lg:text-4xl mt-10 xl:text-5xl flex justify-center w-full font-bold leading-relaxed drop-shadow">
                                    یادگیری برنامه‌نویسی به سبک تمرین‌محور
                                </h1>
                                <p className="mt-10 flex justify-center text-xl lg:text-lg drop-shadow">
                                    با تمرین‌های تعاملی، رقابت، و محیط کدنویسی درون برنامه
                                </p>
                                <div className="w-100 mt-10 flex justify-center">
                                    <ButtonLinkHref className="flex gap-x-5 drop-shadow" openInNewTab={true} to='https://cafebazaar.ir/app/ir.codepro.app.bazaar'>
                                        <span className="text-lg lg:text-md ml-3">دانلود APK از کافه‌بازار</span>
                                        <FontAwesomeIcon icon={faAndroid} size={"xl"} />
                                    </ButtonLinkHref>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </section>
            </main>
            <Footer/>
        </>
    )
        ;
};

export default Home;
